import styled from "styled-components";
import DefaultDIDCard from '../../../../assets/images/default-DID-card.png'
import DIDCardBase from '../../../../assets/images/DID-base.png'
import {Button} from "antd";

const Wrapper = styled.div`
  width: 294px;
  height: 294px;
  border: 1px solid #333333;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .did {
    cursor: pointer;
  }
`

const SyncButton = styled(Button)`
  height: 40px !important;
  border-color: rgb(24, 234, 196) !important;
  color:#000 !important;
  background-color: rgb(24, 234, 196) !important;
  &:hover,
  &:focus-within {
    border-color: rgb(24, 234, 196) !important;
    background-color: rgb(24, 234, 196) !important;
    color:#000 !important;
  };
  box-shadow: 0 0 8px 0 rgba(0,0,0,0.15);
  border-radius: 4px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`

export const DIDCard = ({did}) => {
    const claimDID = () => {
        window.open(process.env.REACT_APP_CLAIM_DID)
    }

    const toHashKey = () => {
        const url = process.env.REACT_APP_HASH_KEY_URL
        url && window.open(url)
    }

    return (
        <Wrapper>
            <img src={did?.did_photo_url ?? DefaultDIDCard} className='did' onClick={toHashKey} width={123} alt=""/>
            <img src={DIDCardBase} width={123} alt=""/>
            {
                !did && (
                    <SyncButton onClick={claimDID}>Claim A DID</SyncButton>
                )
            }
        </Wrapper>
    )
}